// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"81f9c9f4","455":"f7b477e4"}[chunkId] + ".chunk.js";
};